import React, { useEffect, useState, useRef } from "react";
import {useDispatch} from "react-redux";
import { shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/actions";
import {
  AEAutoComplete,
  AEFile, AEInput,
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../../_metronic/_partials/controls";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import {CONTEXT} from "../../../helpers/ModuleHelpers";
import {useIntl} from "react-intl";
import {actionTypes} from "../../../_redux/slice";
import {HTTP_CREATED, HTTP_UPDATED} from "../../../../../../_emywork/helpers/AxiosHelpers";
import {ModuleProvider, useModuleContext} from "../../../ModuleContext";
import {AEButton} from "../../../../../../_emywork/components/buttons";
import {useFormik} from "formik";
import * as Yup from "yup";
import {
  YupAuthEmail, YupAuthPassword, YupAuthPasswordConfirm,
  YupPhone
} from "../../../../../../_emywork/yupjs/Schema";


const validationSchema = Yup.object().shape({
  current: YupAuthPassword(),
  new: YupAuthPassword(),
  _confirm: YupAuthPasswordConfirm("new"),
});

export function PasswordForm(props) {

  return (
    <ModuleProvider>
      <PasswordFormContent {...props} />
    </ModuleProvider>
  )
}
function PasswordFormContent({ history, match: { params: { username }, }}) {

  const {formatMessage} = useIntl();
  const {openDetailsPage} = useModuleContext();
  const dispatch = useDispatch();

  const { isLoading, entity, validationErrors, authUser} = useSelector(state=> {
    //TODO names
    const { isLoading, entity, validationErrors } = state[CONTEXT][actionTypes.EditPassword];
    return {
      isLoading, entity, validationErrors,
      authUser: state.auth.user,
    }
  },shallowEqual)

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: entity,
    initialErrors: validationErrors,
    validationSchema,
    onSubmit: ({...values})=>{
      const {current} = values;
      const object = {current};
      object.new = values.new;

      dispatch(actions.updatePassword({entity:object})).then((r) => {
        if(r.status === HTTP_CREATED){
          openDetailsPage(r.entity.username);
        }
      });
    }
  });

  const { handleSubmit, getFieldProps, setFieldValue, values, setValues } = formik

  const _props = (name, label, type = "password")=>({
    name, label, type,
    field: getFieldProps(name),
    form: formik,
  })

  return (
    <Card>
      <CardHeader title={formatMessage({id: "CHANGE_PASSWORD"})}>
        <CardHeaderToolbar>
          <AEButton
            variant={'primary'}
            className="ml-2"
            onClick={handleSubmit}
          >
            {formatMessage({id:'SAVE_CHANGES'})}
          </AEButton>
          <AEButton
            variant={'light'}
            className="ml-2"
            onClick={()=>{
              history.goBack()
              // openDetailsPage(username)
            }}
          >
            {formatMessage({id:'CANCEL'})}
          </AEButton>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <div className="form-group row">
          <label className="col-xl-3 col-lg-3 col-form-label">
            {formatMessage({id: 'CURRENT_PASSWORD'})}
          </label>
          <div className="col-lg-9 col-xl-6">
            <AEInput
              {..._props('current','CURRENT_PASSWORD')}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-xl-3 col-lg-3 col-form-label">
            {formatMessage({id: 'NEW_PASSWORD'})}
          </label>
          <div className="col-lg-9 col-xl-6">
            <AEInput
              {..._props('new','NEW_PASSWORD')}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-xl-3 col-lg-3 col-form-label">
            {formatMessage({id: 'CONFIRM'})}
          </label>
          <div className="col-lg-9 col-xl-6">
            <AEInput
              {..._props('_confirm','CONFIRM')}
            />
          </div>
        </div>
      </CardBody>
    </Card>
  );
}

